module.exports = {
      id: "portrait-usage",
      viewBox: "0 0 24 24",
      url: __webpack_public_path__ + "svg-sprite-ef426a51ffa8e0d9106d678bb4289730.svg#portrait",
      toString: function () {
        return this.url;
      }
    }